import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router';

/**
 * ScrollToTop
 * Resets the window scroll position to the top on route (pathname) changes.
 * - Skips if there's a hash (anchor navigation should scroll naturally)
 * - Skips on POP (back/forward) to allow browser native history scroll restoration
 *   You can change this behavior by removing the navigationType check.
 */
export function ScrollToTop() {
  const location = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (location.hash) return; // respect in-page anchors
    if (navType === 'POP') return; // keep scroll pos when using back/forward
    // Use instant to avoid jarring smooth animation between pages unless desired.
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [location.pathname, location.hash, navType]);

  return null;
}
